import apiFetch from '../apiFetch'
export default function (includeDeletedValues, includeValue, token) {
  return apiFetch({ endPoint: `ServiceDestination/Types?includeDeletedValues=${includeDeletedValues}&includeValue=${includeValue}`, method: 'GET', body: null, token: token })
}
